import React from 'react'
import footer1 from 'assets/img/shape/footer/footer-1.png'
import footer2 from 'assets/img/shape/footer/footer-2.png'
import footer3 from 'assets/img/shape/footer/footer-3.png'
import footer4 from 'assets/img/shape/footer/footer-4.png'
import {routes} from 'routes/routes'
import {LocalLink} from 'i18n/LocalLink'
import {useI18n} from 'i18n/I18nContext'

export function Footer() {
  const {t} = useI18n()
  return (
    <>
      <footer>
        <section className="footer__area footer-bg fix p-relative pt-145">
          <div className="footer__shape">
            <img
              style={{width: 'auto', height: 'auto'}}
              className="footer__shape-1"
              src={footer1}
              alt=" not found"
            />
            <img
              style={{width: 'auto', height: 'auto'}}
              className="footer__shape-2"
              src={footer2}
              alt=" not found"
            />
            <img
              style={{width: 'auto', height: 'auto'}}
              className="footer__shape-3"
              src={footer3}
              alt=" not found"
            />
            <img
              style={{width: 'auto', height: 'auto'}}
              className="footer__shape-4"
              src={footer4}
              alt=" not found"
            />
          </div>
          <div className="container">
            <div className="row">
              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12">
                <div className="footer__widget-1 mb-70">
                  <div className="footer__logo mb-30">
                    <img
                      src={process.env.PUBLIC_URL + '/logo.svg'}
                      style={{maxWidth: '300px', height: 'auto'}}
                      alt={t('logo.alt')}
                    />
                  </div>
                  <div className="footer__content">
                    <p>{t('footer.tagline')}</p>

                    <div className={'footer__social'}>
                      <a
                        href="https://www.facebook.com/eventatv"
                        target="_blank"
                        rel="noreferrer"
                        aria-label="facebook"
                      >
                        <i className="fa-brands fa-facebook"></i>
                      </a>
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12">
                <div className="footer__widget-2 mb-70">
                  <div className="footer__widget-title">
                    <h3>{t('footer.usefulLinks')}</h3>
                  </div>
                  <div className="footer__link">
                    <ul>
                      <li>
                        <LocalLink to={routes.root}>
                          {t('common.events')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.tickets}>
                          {t('common.tickets')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.info}>
                          {t('footer.whatIsEventaLink')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.help}>
                          {t('common.help')}
                        </LocalLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12">
                <div className="footer__widget-2 mb-70">
                  <div className="footer__widget-title">
                    <h3>{t('footer.information')}</h3>
                  </div>
                  <div className="footer__link">
                    <ul>
                      <li>
                        <LocalLink to={routes.terms}>
                          {t('footer.terms')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.privacy}>
                          {t('footer.privacy')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.cookies}>
                          {t('footer.cookies')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.apiDocs}>
                          {t('footer.apiDocs')}
                        </LocalLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>

              <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-12">
                <div className="footer__widget-3 mb-70">
                  <div className="footer__widget-title">
                    <h3>{t('footer.organization')}</h3>
                  </div>
                  <div className="footer__link">
                    <ul>
                      <li>
                        <LocalLink to={routes.organizations}>
                          {t('menu.forOrganizations')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.organization.login}>
                          {t('common.login')}
                        </LocalLink>
                      </li>
                      <li>
                        <LocalLink to={routes.organization.register}>
                          {t('common.register')}
                        </LocalLink>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="row">
              <div className="col-12">
                <div className="footer__copyright text-center">
                  <p>
                    {t('common.allRightsReserved')}{' '}
                    <a
                      target="_blank"
                      rel="noreferrer"
                      href="https://atomicagroup.com/"
                      aria-label="atomica group website"
                    >
                      Atomica Group
                    </a>{' '}
                    - 2026
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
      </footer>
    </>
  )
}
